import { JobDirectory } from "@container/employer-job-directory";
import AuthLayout from "@container/layout/auth";

export default function EmployerJobPage() {
    return (
        <AuthLayout withoutHeader>
            <JobDirectory />
        </AuthLayout>
    );
}
